import React, { useEffect, useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  Package, 
  Settings, 
  ChevronDown,
  DollarSign,
  X,
  ChevronLeft,
  ChevronRight,
  Factory,
  BarChart3,
  Boxes,
  LogIn,
  LogOut,
  ArrowLeftRight,
  Receipt,
  Settings2,
  PaintBucket,
  Grid3x3,
  Printer,
  Users,
  Book,
  Repeat2,
  CreditCard,
  FileText,
  FileSignature,
  TrendingUp,
  Wallet,
  PackageX,
  BarChart2,
  Calculator,
  Flag,
  UserCog,
  Scale,
  ListChecks,
  Layers,
  Shield,
  Database,
  Gauge,
  FolderKanban,
  BadgeMinus,
  Bell,
  Calendar,
  Plug,
  ShoppingCart,
  UserCheck,
  Clock,
  Palette,
  Banknote,
  ShieldAlert,
  AlertTriangle,
  FileSpreadsheet,
  Inbox,
  FilePlus2,
  FileStack,
  Send,
  Bot
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useAssistant } from '../contexts/AssistantContext';
import { syncPermissions, getMyAbilities } from '../services/rbacService';
import { pathToPermissionKey } from '../utils/permissions';

const Sidebar = ({ open, setOpen }) => {
  const location = useLocation();
  const { user } = useAuth();
  const { openAssistant, isOpen: assistantOpen } = useAssistant();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({
    inventory: false,
    customer: false,
    production: false,
    finance: false,
    efatura: false,
    reports: false,
    management: false,
    fabricInfo: false,
    settings: false
  });

  const navigation = useMemo(() => [
    { 
      name: 'Dashboard', 
      href: '/', 
      icon: Gauge,
      type: 'single'
    },
    { 
      name: 'Stok Yönetimi', 
      icon: Package,
      type: 'expandable',
      key: 'inventory',
      children: [
        { name: 'Stok Kartları', href: '/stock-cards', icon: Package },
        { name: 'Stok Giriş', href: '/stock-entry', icon: LogIn },
        { name: 'Stok Çıkış', href: '/stock-exit', icon: LogOut },
        { name: 'Stok Envanter', href: '/stock-inventory', icon: Boxes },
        { name: 'Stok Hareketleri', href: '/stock-movements', icon: ArrowLeftRight },
        { name: 'Stok Maliyetleri', href: '/stock-costs', icon: Receipt },
        { name: 'Stok Düzenlemeleri', href: '/stock-adjustments', icon: Settings2 }
      ]
    },
    { 
      name: 'Müşteri Yönetimi', 
      icon: Users,
      type: 'expandable',
      key: 'customer',
      children: [
        { name: 'Müşteri Siparişleri', href: '/customer-management/orders', icon: ShoppingCart },
        { name: 'Müşteri Ön Siparişleri', href: '/customer-management/pre-orders', icon: FileText },
        { name: 'Müşteri Ziyaretleri', href: '/customer-management/visits', icon: UserCheck },
        { name: 'İlk Satışlar', href: '/customer-management/first-sales', icon: TrendingUp }
      ]
    },
    { 
      name: 'Üretim Takip', 
      icon: Factory,
      type: 'expandable',
      key: 'production',
      children: [
        { name: 'Boyahane Yönetimi', href: '/uretim-takip/boyahane-yonetimi', icon: PaintBucket },
        { name: 'Örme Yönetimi', href: '/uretim-takip/orme-yonetimi', icon: Grid3x3 },
        { name: 'Baskı Yönetimi', href: '/uretim-takip/baski-yonetimi', icon: Printer }
      ]
    },
    { 
      name: 'Finans Yönetimi', 
      icon: DollarSign,
      type: 'expandable',
      key: 'finance',
      children: [
        { name: 'Cari Kartlar', href: '/current-accounts', icon: Users },
        { name: 'Cari Hesaplar', href: '/finance/current-balances', icon: Book },
        { name: 'Cari Hesap Hareketleri', href: '/finance/current-ledger', icon: Repeat2 },
        { name: 'Ödeme ve Tahsilat', href: '/finance/payments', icon: CreditCard },
        { name: 'Cari Dekont Fişleri', href: '/finance/dekont', icon: FileText },
        { name: 'Çek/Senet Durumu', href: '/finance/check-notes', icon: FileSignature },
        { name: 'Finans Hareketleri', href: '/finance/movements', icon: TrendingUp },
        { name: 'Gider Yönetimi', href: '/finance/expenses', icon: Wallet }
      ]
    },
    {
      name: 'E-Fatura Yönetimi',
      icon: Receipt,
      type: 'expandable',
      key: 'efatura',
      children: [
        { name: 'Fatura Oluştur', href: '/finance/efatura/olustur', icon: FilePlus2 },
        { name: 'Gelen Faturalar', href: '/finance/efatura/gelen', icon: Inbox },
        { name: 'Taslak Faturalar', href: '/finance/efatura/taslaklar', icon: FileStack },
        { name: 'Giden Faturalar', href: '/finance/efatura/giden', icon: Send },
        { name: 'KDV Stoğu', href: '/finance/efatura/kdv-stogu', icon: FileSpreadsheet }
      ]
    },
    { 
      name: 'Analiz ve Raporlar', 
      icon: BarChart3,
      type: 'expandable',
      key: 'reports',
      children: [
        { name: 'Satış Raporları', href: '/reports/sales', icon: BarChart2 },
        { name: 'Atıl Stoklar', href: '/reports/idle-stocks', icon: PackageX },
        { name: 'Kritik Stok Önerisi', href: '/reports/critical-stock-advice', icon: AlertTriangle },
        { name: 'Tahsilat ve Ödeme Raporları', href: '/reports/payment-collection', icon: DollarSign },
        { name: 'Çek ve kredi kartı hareketleri', href: '/reports/check-credit-activity', icon: Banknote },
        { name: 'Stok Planlama', href: '/reports/stock-planning', icon: BarChart3 },
        { name: 'Termin Süresi', href: '/reports/termin-suresi', icon: Clock },
        { name: 'Reklamasyon', href: '/reports/reklamasyon', icon: ShieldAlert }
      ]
    },
    { 
      name: 'Yönetimsel Raporlar', 
      icon: FolderKanban,
      type: 'expandable',
      key: 'management',
      children: [
        { name: 'Aylık Özetler', href: '/management/monthly-summary', adminOnly: true, icon: Calendar },
        { name: 'KPI', href: '/management/kpi', icon: TrendingUp },
        { name: 'Kar Analizi', href: '/management/profit', icon: Calculator },
        { name: 'Hedefler', href: '/management/targets', adminOnly: true, icon: Flag },
        { name: 'Personel', href: '/management/personnel', adminOnly: true, icon: UserCog },
        { name: 'Yönetim Gideri', href: '/management/expenses', adminOnly: true, icon: BadgeMinus },
        { name: 'Bilanço', href: '/management/balance-sheet', adminOnly: true, icon: Scale }
      ]
    },
    { 
      name: 'Araçlar', 
      icon: Settings2,
      type: 'expandable',
      key: 'fabricInfo',
      children: [
        { name: 'Stok Durumu', href: '/stok-durumu', icon: Layers },
        { name: 'Desen Durumu', href: '/desen-durumu', icon: Palette },
        { name: 'Kumaş Bilgileri', href: '/fabric-info', icon: Package },
        { name: 'Giyim Fiyat Hesaplama', href: '/clothing-price-calculator', icon: Calculator }
      ]
    },
    { 
      name: 'Ayarlar', 
      icon: Settings,
      type: 'expandable',
      key: 'settings',
      children: [
        { name: 'Tanımlamalar', href: '/definitions', icon: ListChecks },
        { name: 'Kullanıcı Yönetimi', href: '/users', adminOnly: true, icon: Shield },
        { name: 'Database Erişimi', href: '/settings/database', adminOnly: true, icon: Database },
        { name: 'Bildirim Ayarları', href: '/settings/notifications', adminOnly: true, icon: Bell },
        { name: 'Medianteg Entegrasyonu', href: '/settings/medianteg', adminOnly: true, icon: Plug }
      ]
    },
  ], []);

  // Build permission defs from navigation
  const permissionDefs = useMemo(() => {
    const defs = [
      { key: 'assistant.view', title: 'Jansoft Asistan', category: 'Jansoft Asistan' }
    ];
    const toKey = (href) => href === '/' ? 'dashboard.view' : href.replace(/^\//,'').replaceAll('/', '.') + '.view';
    for (const item of navigation) {
      if (item.type === 'single') {
        defs.push({ key: toKey(item.href || '/'), title: item.name, category: item.name });
      } else if (item.type === 'expandable') {
        for (const child of item.children || []) {
          if (!child.href) continue;
          defs.push({ key: toKey(child.href), title: child.name, category: item.name });
        }
      }
    }
    return defs;
  }, [navigation]);

  useEffect(() => {
    // sync only for admin
    if (user?.role !== 'admin') return;
    syncPermissions(permissionDefs).catch(() => {});
  }, [user, permissionDefs]);

  const [abilities, setAbilities] = useState(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const first = await getMyAbilities();
        if (cancelled) return;
        if (first && Object.keys(first).length > 0) {
          setAbilities(first);
          return;
        }
        // Restart sırasında boş/hatalı cevap gelirse kısa sonra tekrar dene
        await new Promise((r) => setTimeout(r, 1200));
        if (cancelled) return;
        const retry = await getMyAbilities();
        if (!cancelled) setAbilities(retry && typeof retry === 'object' ? retry : {});
      } catch {
        if (cancelled) return;
        await new Promise((r) => setTimeout(r, 1200));
        try {
          const retry = await getMyAbilities();
          if (!cancelled) setAbilities(retry && typeof retry === 'object' ? retry : {});
        } catch {
          if (!cancelled) setAbilities({});
        }
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const isActive = (href) => {
    if (href === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(href);
  };

  const toggleMenu = (key) => {
    setExpandedMenus(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const renderMenuItem = (item) => {
    const canSeeHref = (href) => {
      if (!abilities) return false;
      const key = pathToPermissionKey(href);
      return !!abilities[key];
    };
    const canSeeNavChild = (child) => {
      if (child.type === 'groupLabel') return true;
      if (child.action && !child.href) return true;
      // Admin yeni sayfaları sync öncesi de görsün
      if (user?.role === 'admin') return !!child.href;
      if (!abilities) return false;
      const key = pathToPermissionKey(child.href);
      return !!abilities[key];
    };
    if (item.type === 'expandable') {
      if (item.adminOnly && user?.role !== 'admin') return null;
      const isExpanded = expandedMenus[item.key];
      const visibleChildren = (item.children || [])
        .filter(c => (!c.adminOnly || user?.role === 'admin'))
        .filter((c) => canSeeNavChild(c));
      const linkChildren = visibleChildren.filter((c) => c.href);
      const hasActiveChild = linkChildren.some(child => isActive(child.href));
      if (linkChildren.length === 0) return null;
      
      return (
        <div key={item.name}>
          <button
            onClick={() => toggleMenu(item.key)}
            className={`
              w-full flex items-center py-2 text-sm font-medium rounded-md transition-colors
              ${isCollapsed ? 'justify-center px-2' : 'px-3'}
              ${hasActiveChild 
                ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300' 
                : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
              }
            `}
            title={isCollapsed ? item.name : ''}
          >
            <div className="flex items-center">
              <item.icon className={`${isCollapsed ? 'w-6 h-6' : 'w-5 h-5'} flex-shrink-0`} />
              {!isCollapsed && <span className="ml-3">{item.name}</span>}
            </div>
            {!isCollapsed && (
              <ChevronDown 
                className={`w-4 h-4 transition-transform ${isExpanded ? 'rotate-180' : ''}`} 
              />
            )}
          </button>
          
          {isExpanded && !isCollapsed && (
            <div className="ml-6 mt-1 space-y-1">
              {visibleChildren.map((child) => {
                if (child.adminOnly && user?.role !== 'admin') return null;

                if (child.type === 'groupLabel') {
                  return (
                    <div
                      key={`group-${child.name}`}
                      className="px-3 pt-3 pb-1 text-[10px] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500"
                    >
                      {child.name}
                    </div>
                  );
                }
                
                return (
                  <NavLink
                    key={child.name}
                    to={child.href}
                    onClick={() => setOpen(false)}
                    className={`
                      block px-3 py-2 text-sm rounded-md transition-colors
                      ${isActive(child.href)
                        ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-300'
                        : 'text-gray-600 hover:bg-gray-50 dark:text-gray-400 dark:hover:bg-gray-700'
                      }
                    `}
                  >
                    <span className="flex items-center space-x-2">
                      {child.icon && <child.icon className="w-4 h-4 flex-shrink-0" />}
                      <span>{child.name}</span>
                    </span>
                  </NavLink>
                );
              })}
            </div>
          )}
        </div>
      );
    }

    // Single menu item
    if (item.adminOnly && user?.role !== 'admin') return null;
    if (item.href && abilities && !canSeeHref(item.href)) return null;
    
    return (
      <NavLink
        key={item.name}
        to={item.href}
        onClick={() => setOpen(false)}
        className={`
          flex items-center py-2 text-sm font-medium rounded-md transition-colors
          ${isCollapsed ? 'justify-center px-2' : 'px-3'}
          ${isActive(item.href)
            ? 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
            : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
          }
        `}
        title={isCollapsed ? item.name : ''}
      >
        <item.icon className={`${isCollapsed ? 'w-6 h-6' : 'w-5 h-5'} flex-shrink-0`} />
        {!isCollapsed && <span className="ml-3">{item.name}</span>}
      </NavLink>
    );
  };

  return (
    <>
      {/* Mobile overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-75 z-40 lg:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div 
        className={`
          fixed inset-y-0 left-0 z-50 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 transform transition-all duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0 flex flex-col
          ${open ? 'translate-x-0' : '-translate-x-full'}
          ${isCollapsed ? 'w-16 cursor-pointer' : 'w-64'}
        `}
        onClick={isCollapsed ? toggleSidebar : undefined}
      >
        {/* Header */}
        <div className={`flex items-center justify-between h-16 px-4 border-b border-gray-200 dark:border-gray-700 flex-shrink-0 ${
          isCollapsed ? 'justify-center' : ''
        }`}>
          {!isCollapsed && (
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <img 
                  src="/logo.jpg" 
                  alt="Jansoft Logo" 
                  className="w-8 h-8 object-contain rounded-full"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center" style={{display: 'none'}}>
                  <span className="text-white text-sm font-bold">J</span>
                </div>
              </div>
              <span className="text-lg font-semibold text-gray-900 dark:text-white">
                Jansoft ERP
              </span>
            </div>
          )}
          
          <div className="flex items-center space-x-2">
            <button
              onClick={(e) => {
                if (!isCollapsed) {
                  e.stopPropagation();
                }
                toggleSidebar();
              }}
              className="p-2 rounded-lg text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
              title={isCollapsed ? 'Genişlet' : 'Daralt'}
            >
              {isCollapsed ? (
                <ChevronRight className="w-5 h-5" />
              ) : (
                <ChevronLeft className="w-5 h-5" />
              )}
            </button>
            
            <button
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
              }}
              className="lg:hidden p-2 rounded-lg text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Navigation - Scrollable */}
        <nav className="flex-1 overflow-y-auto overflow-x-hidden mt-6 px-3 pb-6">
          <div className="space-y-1">
            {navigation.map(renderMenuItem)}
          </div>
        </nav>

        {/* Footer — Asistan (sağ alt FAB yerine burada) */}
        <div className="flex-shrink-0 border-t border-gray-200 dark:border-gray-700 p-3 space-y-2">
          {abilities?.['assistant.view'] ? (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                openAssistant();
                if (open) setOpen(false);
              }}
              title="Jansoft Asistan"
              aria-label="Jansoft Asistan"
              aria-pressed={assistantOpen}
              className={`
                w-full flex items-center rounded-lg text-sm font-medium transition-colors
                ${isCollapsed ? 'justify-center px-2 py-2.5' : 'px-3 py-2.5 gap-3'}
                ${assistantOpen
                  ? 'bg-blue-600 text-white shadow-sm'
                  : 'bg-blue-50 text-blue-700 hover:bg-blue-100 dark:bg-blue-950/40 dark:text-blue-200 dark:hover:bg-blue-900/50'}
              `}
            >
              <span className="relative flex-shrink-0">
                <Bot className={isCollapsed ? 'w-6 h-6' : 'w-5 h-5'} />
                <span className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-emerald-400 ring-2 ring-white dark:ring-gray-800" />
              </span>
              {!isCollapsed && <span>Asistan</span>}
            </button>
          ) : null}
          {isCollapsed ? (
            <div className="text-center text-xs font-bold text-gray-700 dark:text-gray-300">J</div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
